import { memo } from 'react';
import { Defs, LinearGradient, Stop } from 'react-native-svg';
import { StatusLinearSvgGradientProps } from './StatusLinearSvgGradient.types';
import { useSvgGradient } from '@bonanza-social/moonlight';

function StatusLinearSvgGradient({ statusName }: StatusLinearSvgGradientProps) {
  const gradientToken = `status${statusName}Background` as const;
  const svgGradient = useSvgGradient(gradientToken);

  return (
    <Defs>
      <LinearGradient
        id={statusName}
        x1={svgGradient.x1}
        y1={svgGradient.y1}
        x2={svgGradient.x2}
        y2={svgGradient.y2}
      >
        {svgGradient.stops.map((stop, index) => (
          <Stop key={index} offset={stop.offset} stopColor={stop.stopColor} />
        ))}
      </LinearGradient>
    </Defs>
  );
}

export default memo(StatusLinearSvgGradient);
